import React, { useContext, useReducer } from 'react';

//Contexto
const TableContext = React.createContext();

//Reducer
const TableReducer = (state, action) => {
    switch (action.type) {
        case 'NEXT_PAGE':
            return {
                ...state,
                [action.tableType]: state[action.tableType] + 1,
            };
        case 'PREVIOUS_PAGE':
            return {
                ...state,
                [action.tableType]: state[action.tableType] - 1,
            };
        case 'INPUT_PAGE':
            return {
                ...state,
                [action.tableType]: action.payload,
            };

        default:
            throw new Error('No action');
    }
};

export function useTableContext() {
    return useContext(TableContext);
}

function TableProvider({ children }) {
    const [state, dispatch] = useReducer(TableReducer, {
        SettingsLogsPage: 1,
        UserPage: 1,
        UserLogsPage: 1,
        DJCPPage: 1,
        DJCPLogsPage: 1,
        DJCEPage: 1,
        DJCELogsPage: 1,
        DJTVPage: 1,
        DJTVLogsPage: 1,
        DJCVPage: 1,
        DJCVLogsPage: 1,
        DJDUVPage: 1,
        DJDUVLogsPage: 1,
        DJMVPage: 1,
        DJMVLogsPage: 1,
        ViniedoPage: 1,
        ViniedoLogsPage: 1,
        GuiaPage: 1,
        GuiaLogsPage: 1,
    });

    return (
        <TableContext.Provider value={{ state, dispatch }}>
            {children}
        </TableContext.Provider>
    );
}

export default TableProvider;
